import api from './index'

const axios = require('axios')

export default {
    getAll: () => {
        const path = '/weekday/all'

        return api.handling(axios.get(path))
    },

    getByID: (id) => {
        const path = `/weekday/${id}`

        return api.handling(axios.get(path))
    },

    updateByID: (id, data) => {
        const path = `/weekday/${id}`

        return api.handling(axios.put(path, data))
    },

    create: (data) => {
        const path = '/weekday/create'

        return api.handling(axios.post(path, data))
    },

    deleteByID: (id) => {
        const path = `/weekday/delete/${id}`

        return api.handling(axios.post(path))
    },

    getMachineListByID: (id) => {
        const path = `/weekday/machines/${id}`

        return api.handling(axios.get(path))
    },

}
